import { Component, ChangeDetectionStrategy } from '@angular/core'
import { ScopeService } from '../../services/scope.service'

@Component({
    selector: 'app-scope',
    templateUrl: './scope.component.html',
    styleUrls: ['./scope.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ScopeComponent {
  scope$ = this.scopeService.scope$
  constructor (
    private scopeService: ScopeService,
  ) {}
}
